export const notificationListStage = {
    REOPEN: "REOPEN",
    APPROVE_CONFIRMATION: "APPROVE_CONFIRMATION",
};

export const changeNotificationTitle = {
    REOPEN: "Changes since last Approval",
    APPROVE_CONFIRMATION: "Approved Updated Case",
};

export const changeNotificationDescription = {
    REOPEN: "Changes were made to this case. Review your edits below before continuing. This case will need re-approval before export.",
    APPROVE_CONFIRMATION:
        "You can still make changes after approval, but you will need to approve the case again before you can export updated files.",
};

export const changeNotificationProceedBtnTxt = {
    REOPEN: "Done",
    APPROVE_CONFIRMATION: "Approve Case",
};
